// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operatorBehaviourPopupSection .MuiDialog-container {
  background: rgba(4, 12, 28, 0.03);
  -webkit-backdrop-filter: blur(7px);
          backdrop-filter: blur(7px);
}
.operatorBehaviourPopupSection .MuiDialog-paper {
  max-width: unset !important;
  min-width: 594px !important;
  margin: unset !important;
  border-radius: 20px !important;
  border: 4px solid rgba(253, 64, 63, 0.33) !important;
  background: linear-gradient(0deg, #5E2229 0%, #5E2229 100%), #11141E !important;
  box-shadow: 0px 4px 60px 0px rgba(26, 36, 62, 0.44) !important;
  padding: 45px 38px !important;
}
.operatorBehaviourPopupSection span {
  color: rgba(255, 255, 255, 0.7);
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
.operatorBehaviourPopupSection .top-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.operatorBehaviourPopupSection .top-container .heading {
  margin: 15px 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 136%;
  color: #FFF;
  font-family: "Poppins";
}
.operatorBehaviourPopupSection .top-container .sub-heading {
  color: #FFF;
  font-family: "Poppins";
  font-size: 22px;
  line-height: 22px;
}
.operatorBehaviourPopupSection .top-container .content-wrapper {
  padding-top: 16px;
  text-align: center;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .assignee {
  display: flex;
  align-items: center;
  gap: 18px;
  justify-content: space-between;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .assignee span {
  padding: 10px;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .assignee .white {
  color: #fff;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .assignee:first-child {
  margin-bottom: 17px;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .assignee:first-child span {
  padding: unset;
}
.operatorBehaviourPopupSection .top-container .content-wrapper .dismiss-btn {
  border-radius: 10px;
  background: #FF8B1E;
  width: 195px;
  height: 51px;
  padding: 8px 10px;
  border: none;
  margin-top: 27px;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 91.523%;
  color: #fff;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/common/OperatorBehaviourPopupSection/styles.scss"],"names":[],"mappings":"AACI;EACI,iCAAA;EACA,kCAAA;UAAA,0BAAA;AAAR;AAEI;EACI,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,oDAAA;EACA,+EAAA;EACA,8DAAA;EACA,6BAAA;AAAR;AAEI;EACI,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;AACZ;AACQ;EACI,WAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AACZ;AACQ;EACI,iBAAA;EACA,kBAAA;AACZ;AAAY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AAEhB;AADgB;EACI,aAAA;AAGpB;AADgB;EACI,WAAA;AAGpB;AAAY;EACI,mBAAA;AAEhB;AADgB;EACI,cAAA;AAGpB;AAAY;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;AAEhB","sourcesContent":[".operatorBehaviourPopupSection{\n    .MuiDialog-container{\n        background: rgba(4, 12, 28, 0.03);\n        backdrop-filter: blur(7px);\n    }\n    .MuiDialog-paper{\n        max-width: unset !important;\n        min-width: 594px !important;\n        margin: unset !important;\n        border-radius: 20px !important;\n        border: 4px solid  rgba(253, 64, 63, 0.33) !important;\n        background: linear-gradient(0deg, #5E2229 0%, #5E2229 100%), #11141E !important;\n        box-shadow: 0px 4px 60px 0px rgba(26, 36, 62, 0.44) !important;\n        padding: 45px 38px !important;\n    }\n    span{\n        color: rgba(255, 255, 255, 0.70);\n        font-family: 'Poppins';\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 140%;\n    }\n    .top-container{\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        .heading{\n            margin: 15px 0;\n            font-size: 24px;\n            font-weight: 700;\n            line-height: 136%;\n            color: #FFF;\n            font-family: 'Poppins';\n        }\n        .sub-heading{\n            color: #FFF;\n            font-family: 'Poppins';\n            font-size: 22px;\n            line-height: 22px;\n        }\n        .content-wrapper{\n            padding-top: 16px;\n            text-align: center;\n            .assignee {\n                display: flex;\n                align-items: center;\n                gap: 18px;\n                justify-content: space-between;\n                span{\n                    padding: 10px;\n                }\n                .white{\n                    color: #fff;\n                }\n            }\n            .assignee:first-child{\n                margin-bottom: 17px;\n                span{\n                    padding: unset;\n                }\n            }\n            .dismiss-btn{\n                border-radius: 10px;\n                background: #FF8B1E;\n                width: 195px;\n                height: 51px;\n                padding: 8px 10px;\n                border: none;\n                margin-top: 27px;\n                font-family: 'Poppins';\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 91.523%;\n                color: #fff;\n                cursor: pointer;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
